import { type TimelineEventDto } from '../../services/api';
import { icon } from '../../icons';
import { t, translateEventType } from '../../services/i18n';
import { esc, EVENT_TYPE_BADGE, EVENT_TYPE_ICONS, formatDate, getTimelineTitle } from './timeline-shared';

export class RcTimelineEventsView extends HTMLElement {
  events: TimelineEventDto[] = [];

  render(): void {
    this.innerHTML = `
      <div class="timeline-toolbar">
        <button class="btn btn-primary btn-sm" data-action="add">${icon('plus', { size: 14, strokeWidth: 2.5 })}${t('timeline.add')}</button>
      </div>
      ${this.events.length === 0
        ? `<div class="empty-state">${icon('calendar', { size: 40, strokeWidth: 1.5, attrs: 'opacity="0.4"' })}<p>${t('timeline.empty')}</p></div>`
        : `<div class="timeline">
            ${this.events.map((event, index) => `
              <div class="timeline-item" data-index="${index}">
                <div class="timeline-connector">
                  <div class="timeline-dot timeline-dot--${event.eventType.toLowerCase()}"></div>
                  ${index < this.events.length - 1 ? '<div class="timeline-line"></div>' : ''}
                </div>
                <div class="timeline-body">
                  <div class="timeline-meta">
                    <span class="badge ${EVENT_TYPE_BADGE[event.eventType] || 'badge-muted'}">${EVENT_TYPE_ICONS[event.eventType] || ''} ${translateEventType(event.eventType)}</span>
                    <span class="timeline-date">${formatDate(event.date)}</span>
                    <button class="btn-icon btn-icon-delete" data-action="delete" data-id="${event.id}" title="${t('common.delete')}">${icon('trash', { size: 13 })}</button>
                  </div>
                  <div class="timeline-title">${esc(getTimelineTitle(event))}</div>
                  ${event.description ? `<div class="timeline-desc">${esc(event.description)}</div>` : ''}
                </div>
              </div>`).join('')}
          </div>`}
    `;
    this.querySelector('[data-action="add"]')?.addEventListener('click', () => this.dispatchEvent(new CustomEvent('timeline-add', { bubbles: true })));
    this.querySelectorAll<HTMLElement>('[data-action="delete"]').forEach((button) => button.addEventListener('click', () => this.dispatchEvent(new CustomEvent('timeline-delete', { bubbles: true, detail: { id: button.dataset.id } }))));
  }
}

if (!customElements.get('rc-timeline-events-view')) {
  customElements.define('rc-timeline-events-view', RcTimelineEventsView);
}
